import { io } from "socket.io-client";
import React, { Component } from 'react';


const config = {
    iceServers: [
        {
            "urls": "stun:stun.l.google.com:19302",
        },
    ]
};

let keyW = false;
let keyA = false;
let keyS = false;
let keyD = false;

class CarControl extends Component {

    constructor(props) {
        super(props);
        const socket = io(process.env.REACT_APP_SOCKET_URL);
        this.timer = 0;
        this.myRef = React.createRef();
        this.state = {
            queueNumber: 0,
            time: {},
            secondsLeft: 600,
            keyBoard: {
                keyA: false,
                keyD: false,
                keyS: false,
                keyW: false
            },
            isLandscape: window.innerHeight < window.innerWidth,
            socket
        }
    }

    changeDroneState = (keyCode, value) => {
        const permitedKeyCodes = [68, 83, 65, 87, 37, 38, 39, 40];
        if (permitedKeyCodes.includes(keyCode)) {
            if (keyCode === 68 || keyCode === 39) {
                keyD = value;
            } else if (keyCode === 83 || keyCode === 38) {
                keyS = value;
            } else if (keyCode === 65 || keyCode === 37) {
                keyA = value;
            } else if (keyCode === 87 || keyCode === 40) {
                keyW = value;
            }
            const data = { keyA, keyD, keyS, keyW }
            this.setState({ keyBoard: data });
            // if (this.state.queueNumber === 0) {
            //     this.state.socket.emit("keyboardState", this.props.match.params.id, data);
            // }
        }
    }
    // send data when user press down button w, s, a, d, up, down left, right 
    onKeyDown = (event) => {
        this.changeDroneState(event.keyCode, true);
    }
    // sends data when user press up button
    onKeyUp = (event) => {
        this.changeDroneState(event.keyCode, false);
    }
    // converts given seconds to h:m:s
    secondsToTime = (secs) => {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }
    requestFullScreen = (element) => {
        // Supports most browsers and their versions.
        var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;

        if (requestMethod) {
            // Native full screen.
            requestMethod.call(element);
        }
    }
    componentDidMount() {
        document.addEventListener("keydown", this.onKeyDown, false);
        document.addEventListener("keyup", this.onKeyUp, false);
        this.timerID = setInterval(
            () => this.tick(),
            50
        );
        // Make the body go full screen.
        this.requestFullScreen(document.body);
        const { socket } = this.state;
        let peerConnection;
        const carId = this.props.match.params.id;
        socket.emit("join", carId);
        socket.emit("watcher", this.props.match.params.id);
        socket.on('queueUpdate', (data) => {
            const { queueNumber, expirationDate } = data;
            console.log("Car queue number is ", queueNumber);
            let deadlineDate = new Date(expirationDate);
            let currentDate = new Date();
            let diff = deadlineDate.getTime() - currentDate.getTime();
            console.log("Time");
            console.log(deadlineDate.getTime());
            console.log(deadlineDate);
            console.log("------");
            console.log(currentDate.getTime());
            console.log(currentDate);
            let secDiff = diff / 1000;
            this.setState({ queueNumber, secondsLeft: secDiff });
            clearInterval(this.timer);
            this.startTimer();
        });

        socket.on("offer", (id, description) => {
            peerConnection = new RTCPeerConnection(config);
            peerConnection
                .setRemoteDescription(description)
                .then(() => peerConnection.createAnswer())
                .then(sdp => peerConnection.setLocalDescription(sdp))
                .then(() => {
                    socket.emit("answer", id, peerConnection.localDescription);
                });
            peerConnection.ontrack = event => {
                if (this.myRef !== null) {
                    this.myRef.srcObject = event.streams[0];
                }
            };
            peerConnection.onicecandidate = event => {
                if (event.candidate) {
                    socket.emit("candidate", id, event.candidate);
                }
            };
        });

        socket.on("candidate", (id, candidate) => {
            peerConnection
                .addIceCandidate(new RTCIceCandidate(candidate))
                .catch(e => console.error(e));
        });

        socket.on("connect", () => {
            socket.emit("watcher");
        });

        socket.on("broadcaster", () => {
            socket.emit("watcher", this.props.match.params.id);
        });

        socket.on('disconnect', () => {
            console.log('user disconnected');
        });

        // let timeLeftVar = this.secondsToTime(this.state.secondsLeft);
        // this.setState({ time: timeLeftVar });
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.onKeyDown, false);
        document.removeEventListener("keyup", this.onKeyUp, false);
        clearInterval(this.timerID);
    }

    tick() {
        // if (this.state.queueNumber === 0) {
        console.log(this.state.keyBoard);
        this.state.socket.emit("keyboardState", this.props.match.params.id, this.state.keyBoard);
        // console.log(this.state.keyBoard);
        // console.log("Hello");
        // }
    }

    handleOnKeyDown = (keyCode) => {
        console.log(keyCode);
        this.changeDroneState(keyCode, true);
    }

    handleOnKeyUp = (keyCode) => {
        console.log(keyCode);
        this.changeDroneState(keyCode, false);
    }

    countDown = () => {
        // Remove one second, set state so a re-render happens.
        let secondsLeft = this.state.secondsLeft - 1;
        this.setState({
            time: this.secondsToTime(secondsLeft),
            secondsLeft: secondsLeft,
        });

        // if (secondsLeft < 0) {
        //     clearInterval(this.timer);
        //     console.log(this.timer);
        // }
    }

    startTimer = () => {
        console.log("Start timer");
        this.timer = setInterval(this.countDown, 1000);
    }
    leftArrow = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 17l-5-5m0 0l5-5m-5 5h12" />
    </svg>
    rightArrow = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
    </svg>
    upArrow = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 11l5-5m0 0l5 5m-5-5v12" />
    </svg>
    downArrow = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 13l-5 5m0 0l-5-5m5 5V6" />
    </svg>
    render() {
        return (
            <div>
                {this.state.isLandscape ?
                    <div className={`bg-gray-600 w-full h-full nav-font text-center ${this.myRef ? 'animate-none' : 'animate-pulse'}`}>
                        {this.state.queueNumber !== -1 ?
                            <div className="relative">
                                <video className="object-cover w-screen h-screen" ref={myRef => { this.myRef = myRef }} playsInline autoPlay muted />
                                <h2 className="absolute text-2xl text-white top-3 left-4">{this.state.queueNumber === 0 ? 'Go' : "You are " + this.state.queueNumber + " in queue"}</h2>
                                <h2 className="absolute text-2xl text-white top-3 right-4">{this.state.time.m}:{this.state.time.s} left</h2>
                            </div>
                            :
                            <a href="/" className="text-2xl text-white font-semibold text-center">
                                The session has ended!
                            </a>
                        }
                    </div> :
                    <div>Please use Landscape!</div>
                }
            </div>
        );
    }
}

export default CarControl;